import { render } from "./ImpuestoForm.vue?vue&type=template&id=0349646f&scoped=true"
import script from "./ImpuestoForm.vue?vue&type=script&lang=js"
export * from "./ImpuestoForm.vue?vue&type=script&lang=js"

import "./ImpuestoForm.vue?vue&type=style&index=0&id=0349646f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0349646f"]])

export default __exports__